export default "__VITE_ASSET__BAADeHyC__";